import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { systems } from '../modules/systems';
import { orders } from '../modules/orders';
import { auth } from '../modules/auth';
import { system } from '../modules/system';
import { productsPortfolio } from '../modules/productsPortfolio';
import { support } from '../modules/support';
import { store as _store } from '../modules/store';
import { metadata } from '../modules/metadata';
import { users } from '../modules/users';
export const store = configureStore({
  reducer: {
    systems,
    orders,
    auth,
    system,
    productsPortfolio,
    store: _store,
    support,
    metadata,
    users,
  },
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({ serializableCheck: false })
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
